$(document).ready(() => {
  $('#iconMenuMobile').on("click", function () {
    setTimeout(() => {
      $('#menu').removeClass("hidden");
    }, 100);
  });
})

document.addEventListener('click', function(event) {
  var popElement = document.getElementsByClassName("menu");
  var isClickInside;
  for (var i = 0; i < popElement.length; i++) {
    isClickInside = popElement[i].contains(event.target);
    if (isClickInside) {
      break;
      //alert("Outside of" + popElement[i].id);
      //the click was outside the popElement, do something
    }
  }
  if(isClickInside){
    // inside
  }else{
    if($('#menu').hasClass('hidden')) {
      //    alert('has class')
    } else {
      $('#menu').addClass("hidden");
    }
  }
});
$(document).ready(function () {
new Swiper(".comments", {
  effect: "coverflow",
  grabCursor: true,
  centeredSlides: true,
  slidesPerView: "auto",
  spaceBetween: 0,
  loop: true,
  loopedSlides: 8,
  coverflowEffect: {
    rotate: 200,
    depth: -800,
    modifier: .1,
    scale: 0.2,
    slideShadows: false
  },
  pagination: {
    el: ".swiper-pagination",
    clickable: true,
  },
  responsive: {
    320: {
      items: 1,
      nav: true
    },
    768: {
      items: 2,
      nav: true
    },
    992: {
      items: 3,
      nav: true
    },
  },
  navigation: {
    nextEl: '.swiper-button-next',
    prevEl: '.swiper-button-prev',
  },
});
});
$(document).ready(function () {
var productSlider = $('.environment').owlCarousel({
  loop: true,
  items: 1,
  margin: 24,
  responsiveClass: true,
  rtl: true,
  nav: false,
  dots: false,
});

$(".custom-environment-nav-next").click(function () {
  productSlider.trigger('next.owl.carousel');
});

$(".custom-environment-nav-prev").click(function () {
  productSlider.trigger('prev.owl.carousel');
});

var dotContainer = jQuery('.environment-dots-class-container');

dotContainer.empty();

productSlider.find('.owl-item:not(.cloned)').each(function (index) {
  dotContainer.append('<div class="custom-dot-class" data-index="' + index + '"></div>');
});

productSlider.on('changed.owl.carousel', function (event) {
  var totalItems = productSlider.find('.owl-item:not(.cloned)').length;
  var currentIndex = event.item.index % totalItems;
  jQuery('.custom-dot-class').removeClass('active');
  jQuery('.custom-dot-class[data-index="' + currentIndex + '"]').addClass('active');
});
});

$(document).ready(function () {
  $('.object-license').owlCarousel({
    loop: false,
    items: 4,
    margin: 24,
    responsiveClass: true,
    rtl: true,
    nav: false,
    dots: false,
    responsive: {
      320: {
        items: 2,
        nav: true
      },
      576: {
        items:3,
        nav: false
      },
     768: {
        items:4,
        nav: false
      },
    },
  });
});

